// extracted by mini-css-extract-plugin
module.exports = {"container":"_2787e5dfdf--container--2aOVe","label":"_2787e5dfdf--label--2zW8J","content":"_2787e5dfdf--content--3USoS"};